module.exports = __webpack_public_path__ + "static/media/twitter.e0adef99.svg";